var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Odoslať do banky")])]), _c('div', {
    staticClass: "splitter noselect"
  }, [_vm._v("1. Vyberte schvaľovateľa, ktorému chcete podklady odoslať")]), _vm._m(0), _vm._m(1), _vm._m(2)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-block p-relative"
  }, [_c('div', {
    staticClass: "div-block-101"
  }, [_c('div', [_vm._v("VÚB Detvianska 22")]), _c('div', {
    staticClass: "bold"
  }, [_vm._v("N. Havlovičová")]), _c('div', {
    staticClass: "text-cta"
  }, [_vm._v(" PICK ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "splitter noselect"
  }, [_vm._v("2. Teraz vyberte jednotlivé súbory ktoré chcete poslať "), _c('br'), _vm._v(" alebo kliknite na "), _c('span', {
    staticClass: "bl-color pop-800"
  }, [_vm._v("VŠETKO")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "link-block-7 w-inline-block d-flex justify-content-between pl-5 pr-5"
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('img', {
    staticClass: "margin-right",
    attrs: {
      "src": require("@/images/cloud_icon.svg"),
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "small"
  }, [_vm._v("pôdorys bytu.JPG")])]), _c('div', {
    staticClass: "text-cta"
  }, [_vm._v(" PICK ")])]);

}]

export { render, staticRenderFns }